<template>
  <div class="p_supply_module p_history_box">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">施工队编号</div>
                    <el-input v-model="listQuery.strConstrteamCode" size="small" clearable></el-input>
                    <!-- <el-select v-model="listQuery.strConstrteamCode" placeholder="" size="small" filterable>
                        <el-option v-for="(item,i) in teamList" :key="i+'d'" :label="item.StrConstrteamCode" :value="item.StrConstrteamCode"></el-option>
                    </el-select> -->
                </div>
                <div class="screenInput">
                  <div class="flname">结算周期</div>
                  <el-date-picker size="small" value-format="yyyy-MM"
                        v-model="listQuery.StrSettleDate" :clearable="false"
                        type="month"
                        placeholder="">
                    </el-date-picker>
                </div>
                <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="是否发送:">
            <el-select v-model="listQuery.strIsSend" size="small" clearable placeholder="">
              <el-option label="已发送" value="1"></el-option>
              <el-option label="未发送" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否确认:">
            <el-select v-model="listQuery.strIsComfirm" size="small" clearable placeholder="">
              <el-option label="已确认" value="1"></el-option>
              <el-option label="未确认" value="0"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="采集平台:">
            <el-select v-model="listQuery.pingtai" size="small" placeholder="">
              <el-option label="宁波人才网" value="宁波人才网"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班地点:">
            <el-input v-model="listQuery.area" size="small" clearable></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
          <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageCrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box">
        <!-- <SupComTabs ref="child" :active="activeName" @change="currChange($event)"></SupComTabs> -->
        <el-tabs v-model="activePageName" @tab-click="handleClick" class="s_tabs_box">
          <el-tab-pane v-if="checkPermission(['verifySummary_tab_summary'],permissionLists)" label="结算核对汇总表" name="third"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['verifySummary_tab_actual'],permissionLists)" label="实发报表" name="first"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['verifySummary_tab_confirm'],permissionLists)" label="确认收款人数据" name="four"></el-tab-pane>
          <el-tab-pane v-if="checkPermission(['verifySummary_tab_history'],permissionLists)" label="历史记录" name="second"></el-tab-pane>
        </el-tabs>
        <div class="r_act_box">
          <div class="r_act_left">
            <div class="r_act_item" v-if="checkPermission(['verifySummary_send_summary'],permissionLists)">
              <el-button size="small" :disabled="isSendFinish" type="success" @click="sendHandle">发送</el-button>
            </div>
            <div class="r_act_item" v-if="!this.isNull(this.tableData)&&checkPermission(['verifySummary_allsend_summary'],permissionLists)">
              <el-button size="small" :disabled="isSendFinish" type="success" @click="allSendHandle">全部发送</el-button>
            </div>
            <div class="r_act_item" v-if="!this.isNull(this.tableData)&&(checkPermission(['verifySummary_export_summary'],permissionLists))">
              <el-button size="small" type="primary" @click="exportHandle" :loading="btnLoading">导出</el-button>
            </div>
          </div>
        </div>
        <el-table ref="multipleTable" class="re_table" :header-cell-style="{background:'#f2f2f2',color: '#909399'}" v-loading="tableLoading" @selection-change="handleSelectionChange" :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%" border>
            <el-table-column type="selection" width="35"></el-table-column>
            <template v-for="(item,index) in tableTitle">
              <el-table-column :prop="item.StrColumId" fit :show-overflow-tooltip="true" :label="item.StrColumName" :key="index" :min-width="item.StrColumName.indexOf('+')>-1||item.StrColumName.indexOf('总计金额')>-1||item.StrColumName.indexOf('负责人身份证')>-1 ? '180px' : item.StrColumName.indexOf('名称')>-1||item.StrColumName.indexOf('原因')>-1||item.StrColumName.indexOf('邮箱')>-1||item.StrColumName.indexOf('时间')>-1?'150px':'110px'" align="center"
                :fixed="item.StrColumName=='施工队名称'">
                <template slot-scope="{row}">
                    <!-- <el-input v-if="item.StrColumName.indexOf('其他应付')>-1" v-model="row[item.StrColumId]" type="number" size="small" clearable :disabled="row.isEditInput"></el-input>
                    <span v-else-if="item.StrColumName.indexOf('本月应付')>-1">{{ Number(row.PriTotal)+Number(row.PriOthermeet)}}</span>
                    <el-input v-else-if="item.StrColumName=='备注'" v-model="row[item.StrColumId]" size="small" clearable :disabled="row.isEditInput"></el-input> -->
                    <span v-if="item.StrColumName.indexOf('是否发送')>-1">
                        {{row.StrIsSend=='1'?'已发送':'未发送'}}
                    </span>
                    <span v-else-if="item.StrColumName.indexOf('是否确认')>-1">
                        {{row.StrIsComfirm=='1'?'已确认':'未确认'}}
                    </span>
                    <span v-else>{{row[item.StrColumId]}}</span>
                </template>
              </el-table-column>
            </template>
            <el-table-column align="center" label="操作" fixed="right" width="320px" class-name="re_act_box">
              <template slot-scope="{row}">
                <el-button v-if="!isNull(row.StrSettleDoc)&&(checkPermission(['verifySummary_download_summary'],permissionLists))" type="info" size="mini" plain @click="downHandle(row)">下载结算汇总</el-button>
                <el-button v-if="!isNull(row.StrDocComfirm)&&(checkPermission(['verifySummary_download_summary'],permissionLists))" type="info" size="mini" plain @click="downHandle02(row)">下载确认结算单</el-button>
                <el-button v-if="checkPermission(['verifySummary_detail'],permissionLists)" type="info" size="mini" plain @click="dtlHandle(row)">明细</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.currpage"
              :page-size="listQuery.perpage"
              @size-change="handleSizeChange"
              :page-sizes="[10, 20, 50, 100, 200]"
              layout="total,sizes,prev,pager,next,jumper"
              :total="total"
            ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="确定下载" :visible.sync="downVisible" width="450px">
      <div style="font-size: 14px;">请确认，是否下载导出数据？</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="downVisible = false">取消</button>
        <button class="search" @click="confirmDown" style="margin-left:10px;font-weight:600">确定</button>
      </span>
    </el-dialog>
    <!-- 详情弹框 -->
    <el-dialog title="结算核对汇总表明细" :visible.sync="dtlVisible" width="900px" class="res_dialog">
        <div class="dia_btns">
          <el-button size="small" type="primary" @click="exportDtlHandle" :loading="btnDiaLoading">导出</el-button>
        </div>
        <el-table class="re_table" :header-cell-style="{background:'#f2f2f2',color: '#909399'}" v-loading="payeeLoading" :max-height="tableHeight-100" :data="payeeData" style="width:100%" border>
            <template v-for="(item,index) in dtlTableTitle">
              <el-table-column :prop="item.StrColumId" fit :show-overflow-tooltip="true" :label="item.StrColumName" :key="index" :min-width="item.StrColumName.indexOf('数量')>-1 ? '160px' : item.StrColumName.indexOf('名称')>-1||item.StrColumName.indexOf('时间')>-1?'150px':'110px'" align="center"
                :fixed="item.StrColumName=='施工队名称'">
                <template slot-scope="{row}">
                    <span v-if="item.StrColumName.indexOf('是否发送')>-1">
                        {{row.StrIsSend=='1'?'已发送':'未发送'}}
                    </span>
                    <span v-else-if="item.StrColumName.indexOf('是否确认')>-1">
                        {{row.StrIsSend=='1'?'已确认':'未确认'}}
                    </span>
                    <span v-else>{{row[item.StrColumId]}}</span>
                </template>
              </el-table-column>
            </template>
        </el-table>
        <el-pagination
              @current-change="handleCurrentChange02"
              :current-page.sync="dtlQuery.currpage"
              :page-size="dtlQuery.perpage"
              @size-change="handleSizeChange02"
              :page-sizes="[10, 20, 50, 100, 200]"
              layout="total,sizes,prev,pager,next,jumper"
              :total="dtltotal"
        ></el-pagination>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary" class="com_dialog_btn"
            @click="dtlVisible = false"
            size="small"
            >关闭</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment'
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        isSendFinish:false,
        btnDiaLoading:false,
        activePageName:'third',
        teamList:[],//施工队列表
        teamQuery:{
          strConstrteamName:'',// 施工队名称
          strSerStatus:'',// 服务状态 正常/退出
          strExamStatus:'',// 通过/不通过
          strArea:'',//区域
          strCityCompany:'',//城市公司
          currpage:1,
          perpage:1000000
        },
        isEditInput:true,
        downVisible:false,
        btnLoading:false,
        custPath: '',//导出文件下载路径
        tablePath: this.$store.state.EMP.tablePath,
        docPath: this.$store.state.EMP.docPath,
        tableHeight: 0,
        showDropScreen:-1,
        pageCrumb:'结算核对汇总表',
        activeName:'seven',
        tableData: [],
        dateRangeVal:[],
        listQuery:{
            StrSettleDate:'',// 日期
            strConstrteamCode:'',// 施工队编号
            strIsSend:'',//是否发送
            strIsComfirm:'',//是否确认
            currpage:1,
            perpage:10
        },
        // 表头参数
        titleQuery:{
          strTableId:'JB_report_BillMonth',//JB_report_BillMonth 结算单 JB_busi_UtilityBill_Detail 详情
          strIsFixed:''
        },
        // 导出参数
        exportQuery:{},
        isSearchHandle:false,
        tableLoading:false,
        // 表头数据
        tableTitle:[],
        total:0,
        StrActualDate:'',
        multipleSelection: [],
        // 修改金额参数
        editPriceQuery:{
            gdCordid:'',
            PriOthermeet:'',//其他应收
            PriMonthmeet:'',//本月应收
            StrRemark:''//备注
        },
        //选中是发送数据
        selSendList:[],
        sendQuery:{
            gdbillIDs:'',
            strtype:'',// all 全部
            strSettleDate:''//月份
        },
        dtlVisible:false,
        payeeData:[],//明细表数据
        payeeLoading:false,
        // 结算核对汇总表明细
        dtlQuery:{
            currpage:1,
            perpage:10,
            StrSettleDate:'',// 选择月份
            strConstrteamCode:''// 施工队编号
        },
        // 表头参数
        dtlTitleQuery:{
          strTableId:'JB_busi_UtilityBill_Detail',//JB_report_BillMonth 结算单 JB_busi_UtilityBill_Detail 详情
          strIsFixed:''
        },
        dtlTableTitle:[],
        dtltotal:0,
        // 按钮权限参数
        butQuery:{
          path:'/verifySummary',
          powerEnName:'supplierManage'
        },
        permissionLists:[]
      }
    },
    created() {
        this.calHeight();
        let lastDate = moment().subtract(1,'months').format("YYYY-MM")
        this.listQuery.StrSettleDate = lastDate
        this.getButtonPower()
        if(!this.isNull(this.$route.query.active)){
          this.activePageName = this.$route.query.active
          this.getTableTitleLists(this.titleQuery,'list')
          this.getTeamList()
        }
    },
    methods: {
      checkPermission,
        // 获取按钮权限
        getButtonPower(){
          let param = this.$route.query.active
          xz.getbtnPowerIdBypage(this.butQuery).then(res => {
            // console.log('按钮',res)
            if(res.status == 'ok'){
              let resmsg = res.msg
              if(!this.isNull(resmsg)){
                for (let index = 0; index < resmsg.length; index++) {
                  let element = resmsg[index];
                  this.permissionLists.push(element.Enname);
                }
                if(this.checkPermission(['verifySummary_tab_summary'],this.permissionLists)&&(this.isNull(param))){
                  this.activePageName = 'third'
                  this.getTableTitleLists(this.titleQuery,'list')
                  this.getTeamList()
                }else if((!this.checkPermission(['verifySummary_tab_summary'],this.permissionLists))&&(this.checkPermission(['verifySummary_tab_actual'],this.permissionLists))&&(this.isNull(param))){
                  this.$router.push({
                      path: '/generatedRecords',
                      query:{
                          active:'first'
                      }
                  })
                }else if((!this.checkPermission(['verifySummary_tab_summary'],this.permissionLists))&&(!this.checkPermission(['verifySummary_tab_actual'],this.permissionLists))&&(this.checkPermission(['verifySummary_tab_confirm'],this.permissionLists))&&(this.isNull(param))){
                  this.$router.push({
                      path: '/receiptConfirmation',
                      query:{
                          active:'four'
                      }
                  })
                }else if((!this.checkPermission(['verifySummary_tab_summary'],this.permissionLists))&&(!this.checkPermission(['verifySummary_tab_actual'],this.permissionLists))&&(!this.checkPermission(['verifySummary_tab_confirm'],this.permissionLists))&&(this.checkPermission(['verifySummary_tab_history'],this.permissionLists))&&(this.isNull(param))){
                  this.$router.push({
                      path: '/historyReport',
                      query:{
                          active:'second'
                      }
                  })
                }
                
              }else{
                this.permissionLists = []
                this.activePageName = ''
              }
            }else{
              this.permissionLists = []
              this.activePageName = ''
            }
          })
        },
        calHeight() {
            this.tableHeight = Number(document.body.clientHeight);
            // console.log('height', this.tableHeight)
        },
        // 汇总表明细导出
        exportDtlHandle(){
          let exportQuery = {};
          exportQuery = JSON.parse(JSON.stringify(this.dtlQuery))
          // exportQuery.strConstrteamCode = this.dtlQuery.strConstrteamCode
          exportQuery.currpage = 1
          exportQuery.perpage = 1000000
          this.btnDiaLoading = true
          // console.log('ll',param)
          xz.OutputTeamList(exportQuery,'JB_busi_UtilityBill_Detail').then(res => {
            // console.log('ll',res)
            if (res.status == 'ok') {
              let path = this.tablePath + res.stroutpath
              let aTag1 = document.createElement('a')
              aTag1.href = path
              aTag1.click();
              this.$message({
                type: 'success',
                message: '导出成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: '导出失败，请稍后再试'
              })
              return false
            }
            this.btnDiaLoading = false
          })
        },
        // 下载汇总(自动生成excel)
        downHandle(row){
          let d = row.StrSettleDoc
          // d = d.replace("\"", "").replace("\"", "")
          let path = this.tablePath + d
          let aTag = document.createElement('a')
          aTag.href = path
          aTag.click();
        },
        // 下载确认汇总
        downHandle02(row){
          let d = row.StrDocComfirm
          // d = d.replace("\"", "").replace("\"", "")
          let path = this.docPath + d
          let aTag = document.createElement('a')
          aTag.href = path
          aTag.click();
        },
        // 详情
        dtlHandle(row){
            this.dtlVisible = true
            this.dtlQuery.StrSettleDate = row.StrSettleDate
            this.dtlQuery.strConstrteamCode = row.StrConstrteamCode
            this.getTableTitleLists(this.dtlTitleQuery,'dtl')
        },
        // 获取详情
        getDtlList(){
            xz.getBillMonthinfdetailList(this.dtlQuery).then(res => {
            if (res.status == 'ok') {
                this.payeeData = res.msg
                this.dtltotal = res.totalcount
            }else{
                this.payeeData = []
                this.dtltotal = 0
            }
            this.payeeLoading = false
            // console.log('表头', res)
          })
        },
        //分页
        handleCurrentChange02(val){
            this.dtlQuery.currpage = Number(val)
            this.getList()
        },
        handleSizeChange02(val) {
            this.dtlQuery.currpage = 1
            this.dtlQuery.perpage = Number(val)
            this.getList()
        },
        // 发送
        sendHandle(){
            this.sendQuery.strtype = ''
            this.sendQuery.gdbillIDs = this.selSendList.toString()
            if(this.isNull(this.sendQuery.gdbillIDs)){
                this.$message({ type: 'warning', message: '请选择要发送的数据' })
                return
            }
            this.$confirm('此操作将发送该数据，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.comSendRequest()
            })
        },
        // 全部发送
        allSendHandle(){
            this.sendQuery.strtype = 'all'
            this.sendQuery.gdbillIDs = ''
            this.$confirm('此操作将发送该数据，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.comSendRequest()
            })
        },
        comSendRequest(){
          this.isSendFinish = true
            this.sendQuery.strSettleDate = this.listQuery.StrSettleDate
            xz.sendBillMonthinf(this.sendQuery).then(res => {
                if (res.status == 'ok') {
                    this.$message({ type: 'success', message: '操作成功' })
                    this.getList()
                }else{
                    this.$message({ type: 'error', message: '操作失败，请稍后再试' })
                }
                this.isSendFinish = false
                // console.log('表头', res)
            })
        },
        handleSelectionChange(val) {
            this.selSendList = []
            this.multipleSelection = val;
            // console.log('ff',val)
            if(!this.isNull(val)){
                for (let i = 0; i < val.length; i++) {
                    let element = val[i];
                    this.selSendList.push(element.GdbillId)
                }
            }
        },
        // 获取施工队列表
        getTeamList(){
            xz.getConstrTeamLists(this.teamQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                  this.teamList = res.msg
                }else{
                  this.teamList = []
                }
            })
        },
        // 导出
        exportHandle(){
          this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
          this.exportQuery.currpage = 1
          this.exportQuery.perpage = 1000000
          this.btnLoading = true
          // console.log('ll',param)
          xz.OutputTeamList(this.exportQuery,'JB_report_BillMonth').then(res => {
            // console.log('ll',res)
            if (res.status == 'ok') {
              this.custPath = res.stroutpath
              this.downVisible = true
            } else {
              this.$message({
                type: 'error',
                message: '导出失败，请稍后再试'
              })
              return false
            }
            this.btnLoading = false
          })
        },
        handleClick(tab){
            // console.log('tab',tab)
            if(tab.name == 'second'){
                this.$router.push({
                    path: '/historyReport',
                    query: {
                        active: 'second'
                    }
                })
            }
            if(tab.name == 'first'){
                this.$router.push({
                    path: '/generatedRecords',
                    query:{
                      active:'first'
                    }
                })
            }
            if(tab.name == 'four'){
                this.$router.push({
                    path: '/receiptConfirmation',
                    query:{
                          active:'four'
                      }
                })
            }
        },
        // 确定下载导出数据
        confirmDown() {
          let path = this.tablePath + this.custPath
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click();
          this.downVisible = false
        },
        // 获取表头
        getTableTitleLists(query,type){
          if(type == 'dtl'){
            this.payeeLoading = true
          }
          xz.getEcustColumnList(query.strTableId,query.strIsFixed).then(res => {
            if (res.status == 'ok') {
                if(type == 'list'){
                    this.tableTitle = res.msg
                    this.getList()
                }
                if(type == 'dtl'){
                    this.dtlTableTitle = res.msg
                    this.getDtlList()
                }
            }else{
                if(type == 'list'){
                    this.tableTitle = []
                }
                if(type == 'dtl'){
                    this.dtlTableTitle = []
                }
            }
            // console.log('表头', res)
          })
        },
        // 获取列表
        getList(){
            this.tableLoading = true
            this.isSearchHandle = true
            xz.getBillMonthLists(this.listQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                    this.tableData = res.msg
                    this.total = res.totalcount
                }else{
                  this.tableData = []
                  this.total = 0
                }
              this.tableLoading = false
              this.isSearchHandle = false
              this.$store.commit("setSupComTabsIsover", true);
            })
        },
        //分页
        handleCurrentChange(val){
            this.listQuery.currpage = Number(val)
            this.getList()
        },
        handleSizeChange(val) {
            this.listQuery.currpage = 1
            this.listQuery.perpage = Number(val)
            this.getList()
        },
        // 搜索
        searchHandle(){
            this.listQuery.currpage = 1
            this.getList()
        },
        // 清空
        resetHandle(){
            this.listQuery = this.$options.data.call(this).listQuery
            let lastDate = moment().subtract(1,'months').format("YYYY-MM")
            this.listQuery.StrSettleDate = lastDate
            
        },
        //筛选下拉
        dropDownScreen() {
            if (this.showDropScreen == -1) {
            this.showDropScreen = 1;
            } else if (this.showDropScreen == 1) {
            this.showDropScreen = -1;
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
        },
        isNullNotZero(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || (o+'') == '' || o == 'null' || o == 'NaN';
        }
    }
  }
</script>

<style scoped>
.dia_btns{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.f_box{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.f_left{
    width: 60px;
    text-align: right;
    margin-right: 4px;
}
.add_form_item{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.add_form_item .s_input{
    margin-right: 6px;
    width: 220px;
    text-align: center;
}
.dlt_icon{
    display: inline-block;
    font-size: 18px;
    color:#999;
    margin-left:20px;
    cursor: pointer;
}
.add_title_box{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
    margin-bottom: 10px;
}
.t_item{
    width: 220px;
    text-align: center;
}
.p_clue_box{
    background-color: #fff;
}
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 15px 15px;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
}
.r_dropDownScreen{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
}
.re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
}
</style>
<style>
.p_history_box .el-date-editor.el-input__inner{
    width: 260px!important;
}
.p_history_box .el-input.is-disabled .el-input__inner{
    background-color: #fff;
    border-color: #fff;
    text-align: center;
}
.p_supply_module .el-form-item__label{
  padding: 0 5px 0 0;
}
.p_supply_module .el-tabs{
    background-color: #fff;
    padding: 0 10px;
}
.p_supply_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}
.p_supply_module .screenInputs .screenInput .el-select .el-input__inner,
.p_supply_module .re_down_form.el-form--inline .el-form-item__content,
.p_supply_module .re_down_form .el-select,
.p_supply_module .re_down_form .el-form-item__content,
.p_supply_module .screenInput .el-input{
  width: 200px;
}
.re_table.el-table .cell{
padding: 0 5px;
}
.re_table.el-table .el-table__cell{
padding: 3px 0;
}
</style>